"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ComputedFieldHandler", {
    enumerable: true,
    get: function() {
        return ComputedFieldHandler;
    }
});
const _generic = require("./generic");
let ComputedFieldHandler = class ComputedFieldHandler extends _generic.GenericFieldHandler {
    async parseUserInput(_params) {
        return {
            value: undefined
        };
    }
};
